import * as PROJECT_CODE from '../../constants/projectCode';

export async function SaveOrUpdateDocument(
	firebase,
	infoToUpdate,
	thisClientEmail,
	coBrokersSalesAgent,
	clientCreatorId
) {
	var currentUserId = firebase.auth().currentUser.uid;

	if (coBrokersSalesAgent !== null && coBrokersSalesAgent !== undefined) {
		currentUserId = coBrokersSalesAgent;
	} else if (clientCreatorId) {
		currentUserId = clientCreatorId;
	}

	console.log('SaveOrUpdateDocument currentUserId after', currentUserId);

	var thisSalesAgentPointer;

	await firebase
		.database()
		.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
		.orderByChild('createrID')
		.equalTo(currentUserId)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			var allKeys = Object.keys(snapData);

			//var keyToCall = snapData[allKeys[0]];

			thisSalesAgentPointer = allKeys[0];
		});

	var salesAgentRef = firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				thisSalesAgentPointer +
				'/myClients'
		);

	var clientReferenceKey;

	await salesAgentRef
		.orderByChild('clientEmail')
		.equalTo(thisClientEmail)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			console.log('SnapData 2', snapData);

			if (snapData !== undefined && snapData !== null) {
				var allKeys = Object.keys(snapData);

				if (allKeys.length > 0) {
					var keyToCall = allKeys[0];

					clientReferenceKey = keyToCall;
				}
			}
		});

	if (clientReferenceKey === null || clientReferenceKey === undefined) {
		var newClientPush = salesAgentRef.push();

		var jsonToPush = {
			documentInformation: infoToUpdate,
			clientEmail: thisClientEmail,
		};

		newClientPush.set(jsonToPush);
	} else {
		var jsonToPush = {
			documentInformation: infoToUpdate,
			clientEmail: thisClientEmail,
		};

		salesAgentRef.child(clientReferenceKey).update(jsonToPush);
	}
}

export async function GetDocumentRef(
	firebase,
	thisClientEmail,
	coBrokersSalesAgent
) {
	console.log('saveOrUpdateDocumentmjojoj', coBrokersSalesAgent);

	var currentUserId;

	if (coBrokersSalesAgent !== undefined && coBrokersSalesAgent !== null) {
		console.log('coBrokersSalesAgent', coBrokersSalesAgent);
		currentUserId = coBrokersSalesAgent;
	} else {
		console.log('coBrokersSalesAgent else', coBrokersSalesAgent);
		currentUserId = firebase.auth().currentUser.uid;
	}

	var thisSalesAgentPointer;

	console.log('GetDocumentRef');

	console.log('GetDocumentRef My id ', currentUserId);

	await firebase
		.database()
		.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
		.orderByChild('createrID')
		.equalTo(currentUserId)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			console.log('SnapData ', snapData);

			var allKeys = Object.keys(snapData);

			//var keyToCall = snapData[allKeys[0]];

			thisSalesAgentPointer = allKeys[0];

			console.log('GetDocumentRef key', thisSalesAgentPointer);
		});

	var salesAgentRef = firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				thisSalesAgentPointer +
				'/myClients'
		);

	var clientReferenceKey;

	console.log('GetDocumentRef client email', thisClientEmail);

	await salesAgentRef
		.orderByChild('clientEmail')
		.equalTo(thisClientEmail)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			console.log('SnapData 2', snapData);

			if (snapData !== undefined && snapData !== null) {
				var allKeys = Object.keys(snapData);

				if (allKeys.length > 0) {
					var keyToCall = allKeys[0];

					clientReferenceKey = keyToCall;
				}

				console.log('client reference key ', clientReferenceKey);
			}
		});

	console.log(
		'Ref we should of made ' +
			'kavtek_clients/' +
			PROJECT_CODE.projectCode +
			'/salesAgents/' +
			thisSalesAgentPointer +
			'/myClients/' +
			clientReferenceKey +
			'/documentInformation/document'
	);

	var finalRef = firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				thisSalesAgentPointer +
				'/myClients/' +
				clientReferenceKey +
				'/documentInformation/document'
		);

	return finalRef;
}

export async function SaveClientSignatureRequestInfo(
	firebase,
	unclaimedDraftJson,
	thisClientEmail,
	subjectName,
	clientCreatorId
) {
	console.log('saveOrUpdateDocument');

	console.log(
		'SaveClientSignatureRequestInfo clientCreatorId',
		clientCreatorId
	);

	var currentUserId;
	if (clientCreatorId !== null && clientCreatorId !== undefined && clientCreatorId !=="") {
		console.log('SaveClientSignatureRequestInfo not null', clientCreatorId);
		currentUserId = clientCreatorId;
	} else {
		console.log(
			'SaveClientSignatureRequestInfo current user',
			clientCreatorId
		);
		currentUserId = firebase.auth().currentUser.uid;
	}

	var thisSalesAgentPointer;

	console.log('My id ' + currentUserId);

	await firebase
		.database()
		.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
		.orderByChild('createrID')
		.equalTo(currentUserId)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			console.log('SnapData ' + JSON.stringify(snapData));

			var allKeys = Object.keys(snapData);

			//var keyToCall = snapData[allKeys[0]];

			thisSalesAgentPointer = allKeys[0];

			console.log('GetDocumentRef key' + thisSalesAgentPointer);
		});

	var salesAgentRef = firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				thisSalesAgentPointer +
				'/myClients'
		);

	var clientReferenceKey;

	console.log('GetDocumentRef client email', thisClientEmail);

	await salesAgentRef
		.orderByChild('clientEmail')
		.equalTo(thisClientEmail)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			console.log('SnapData 2' + JSON.stringify(snapData));

			if (snapData !== undefined && snapData !== null) {
				var allKeys = Object.keys(snapData);

				if (allKeys.length > 0) {
					var keyToCall = allKeys[0];

					clientReferenceKey = keyToCall;
				}

				console.log('client reference key ', clientReferenceKey);
			}
		});

	var finalRef = firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				thisSalesAgentPointer +
				'/myClients/' +
				clientReferenceKey +
				'/documentInformation/signatureRequests'
		);

	console.log(
		'SET SIG UPDATE ' +
			'kavtek_clients/' +
			PROJECT_CODE.projectCode +
			'/salesAgents/' +
			thisSalesAgentPointer +
			'/myClients/' +
			clientReferenceKey +
			'/documentInformation/signatureRequests'
	);

	var newSignatureRequest = finalRef.push();

	unclaimedDraftJson['timestamp'] = Date.now();
	unclaimedDraftJson['subject'] = subjectName;

	newSignatureRequest.set(unclaimedDraftJson);
}

export async function SaveClientSignatureRequestInfoExtras(
	firebase,
	unclaimedDraftJson,
	thisClientEmail,
	subjectName,
	clientCreatorId
) {
	console.log('saveOrUpdateDocument');

	var currentUserId = clientCreatorId;

	var thisSalesAgentPointer;

	console.log('My id ' + currentUserId);

	await firebase
		.database()
		.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
		.orderByChild('createrID')
		.equalTo(currentUserId)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			console.log('SnapData ' + JSON.stringify(snapData));

			var allKeys = Object.keys(snapData);

			//var keyToCall = snapData[allKeys[0]];

			thisSalesAgentPointer = allKeys[0];

			console.log('GetDocumentRef key' + thisSalesAgentPointer);
		});

	var salesAgentRef = firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				thisSalesAgentPointer +
				'/myClients'
		);

	var clientReferenceKey;

	console.log('GetDocumentRef client email' + thisClientEmail);

	await salesAgentRef
		.orderByChild('clientEmail')
		.equalTo(thisClientEmail)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			console.log('SnapData 2' + JSON.stringify(snapData));

			if (snapData !== undefined && snapData !== null) {
				var allKeys = Object.keys(snapData);

				if (allKeys.length > 0) {
					var keyToCall = allKeys[0];

					clientReferenceKey = keyToCall;
				}

				console.log('client reference key ' + clientReferenceKey);
			}
		});

	var finalRef = firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				thisSalesAgentPointer +
				'/myClients/' +
				clientReferenceKey +
				'/documentInformation/signatureRequestsExtras'
		);

	var newSignatureRequest = finalRef.push();

	unclaimedDraftJson['timestamp'] = Date.now();
	unclaimedDraftJson['subject'] = subjectName;

	newSignatureRequest.set(unclaimedDraftJson);
}
